import { create } from 'zustand'

interface DropdownLocationSweepstakesParticipatingLocations {
  dropdownLocationSweepstakesParticipatingLocationsValue: string
  setdropdownLocationSweepstakesParticipatingLocationsValue: (
    dropdownLocationSweepstakesParticipatingLocationsValue: string
  ) => void
}

export const useDropdownLocationSweepstakesParticipatingLocationsStore =
  create<DropdownLocationSweepstakesParticipatingLocations>((set) => ({
    dropdownLocationSweepstakesParticipatingLocationsValue: '',
    setdropdownLocationSweepstakesParticipatingLocationsValue: (
      dropdownLocationSweepstakesParticipatingLocationsValue: any
    ) => {
      set({ dropdownLocationSweepstakesParticipatingLocationsValue })
    },
  }))
